import { ProgressBar } from "react-bootstrap";

export type WizardProgressBarProps = {
  totalSteps: number;
  currentStep: number;
};

export const WizardProgressBar: React.FC<WizardProgressBarProps> = (props) => {
  return (
    <>
      <ProgressBar
        min={0.99}
        max={props.totalSteps + 0.01}
        now={props.currentStep}
        label={`Step ${props.currentStep} of ${props.totalSteps}`}
        visuallyHidden={true}
        variant="info"
      />
      <div className="d-flex m-2 justify-content-center">
        Step {props.currentStep} of {props.totalSteps}
      </div>
    </>
  );
};
